import { useMemo } from 'react';
import { SortContext } from './SortContext';
export function SortProvider(props) {
    const { children, id, order, onSort, hideColRows } = props;
    return (<SortContext.Provider value={useMemo(() => ({ id, order, onSort, hideColRows }), [id, order, onSort, hideColRows])}>
      {children}
    </SortContext.Provider>);
}
